import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { forwardRef } from 'react';
import { Container } from '../Container.js';
export const IconFlightTakeoff = forwardRef((props, ref) => _jsx(Container, {
  "data-testid": "IconFlightTakeoff",
  ref: ref,
  ...props,
  children: _jsx("path", {
    d: "M800-120H160q-17 0-28-11t-12-29 12-28 28-12h640q17 0 29 12t11 28-11 29-29 11M212-464l192-52-139-236q-8-14-3-30t22-21l17-5q9-3 18-1t16 8l259 233 200-54q32-9 58 12t26 56q0 22-13 39t-35 23L223-328q-13 4-25-1t-19-17L98-484q-7-11-1-23t18-14l15-3q6-1 11 1t10 5z"
  })
}));
IconFlightTakeoff.displayName = 'IconFlightTakeoff';